/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Friend_Guest_SuccessInputs */

const fr_membership_friend_guest_success = /** @type {(inputs: Membership_Friend_Guest_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'est noté, l'accueil attend votre ami.`)
};

/**

* @param {Membership_Friend_Guest_SuccessInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_friend_guest_success = /** @type {((inputs?: Membership_Friend_Guest_SuccessInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Friend_Guest_SuccessInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_friend_guest_success(inputs)
});